import { bool } from "prop-types";

import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrFade from "UI/FnrFade";
import FnrHelpEmailLink from "UI/FnrHelpEmailLink/FnrHelpEmailLink";
import FnrTextLink from "UI/FnrTextLink";
import FnrTypography from "UI/FnrTypography";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";

const HELP_FAQ_URL =
  "https://help.flocknote.com/article/50-how-do-i-setup-a-login";

const FnrHelpInvitation = ({ showLogo }) => {
  return (
    <FnrHorizontalGap gap={4} data-cy="FnrHelpInvitation_Container">
      <FnrFade show={showLogo} top={false} left>
        <FnrContainedIcon
          icon="uno"
          color="fnBlue"
          data-cy="FnrHelpInvitation_Icon"
        />
      </FnrFade>
      <FnrTypography type="copy" fontSize="0.99em">
        Need help? Read our <FnrTextLink href={HELP_FAQ_URL}>FAQ</FnrTextLink>{" "}
        or email <FnrHelpEmailLink />
      </FnrTypography>
    </FnrHorizontalGap>
  );
};

FnrHelpInvitation.propTypes = { showLogo: bool };

export default FnrHelpInvitation;
